export default {"src":"/_next/static/media/paint-color-selection.8cd98a0c.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};